import { Avatar, Badge, BadgeProps, Flex, LoadingOverlay } from "@mantine/core";
import styled from "styled-components";

type PhotoUploadProps = {
  type: string;
  label: string;
  photo: File | null;
  preview: string | null;
  overlayVisible: boolean;
  loading: boolean;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>, type: string) => void;
  setOverlayVisible: (visible: boolean) => void;
};

const PhotoUploadInput = ({
  type,
  label,
  photo,
  preview,
  overlayVisible,
  loading,
  onFileChange,
  setOverlayVisible,
}: PhotoUploadProps) => {
  const displayImage = preview;

  return (
    <Flex direction="column" align="start" justify="start" pos="relative">
      <InputLabel>{label}</InputLabel>
      <FileInput
        id={`${type}-file-upload`}
        type="file"
        onChange={(e) => onFileChange(e, type)}
      />
      <FileLabel
        htmlFor={`${type}-file-upload`}
        onMouseEnter={() => setOverlayVisible(true)}
        onMouseLeave={() => setOverlayVisible(false)}
      >
        <LoadingOverlay
          visible={loading}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        {displayImage ? (
          <PhotoPreview
            src={displayImage}
            alt={`${type} preview`}
            height="100%"
            width="100%"
            style={{ objectFit: "contain", borderRadius: "8px" }}
            $isChanged={!!photo}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "10px",
              border: "2px dashed #5C26FF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 0px 20px 0px #00000026",
            }}
          >
            <Badge bg="#5C26FF" circle size="40" style={{ cursor: "pointer" }}>
              <Avatar src="/assets/plusIcon.png" size={28} />
            </Badge>
          </div>
        )}
        {(overlayVisible && displayImage) || photo ? (
          <UploadIcon circle>
            <Avatar src="/assets/uploadIcon.png" size={24} radius={0} />
          </UploadIcon>
        ) : null}
      </FileLabel>
    </Flex>
  );
};

export default PhotoUploadInput;

const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  line-height: 17.64px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const FileInput = styled.input`
  display: none;
`;

const FileLabel = styled.label`
  width: 160px;
  height: 160px;
  position: relative;
  display: inline-block;
  margin-top: 10px;
  cursor: pointer;
  }
`;

const PhotoPreview = styled.img<{ $isChanged: any }>`
  border: 2px solid
    ${(props): any => (props.$isChanged ? "#5C26FF" : "#d9d9d9")};
  border-radius: 8px;
  transition: border-color 0.3s ease;
  &:hover {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
  }
`;

const UploadIcon = styled(Badge)<BadgeProps>`
  position: absolute;
  width: 40px;
  height: 40px;
  top: -20px;
  right: -20px;
  background: #5c26ff;
  color: white;
  font-size: 20px;
  font-weight: bold;
  z-index: 10;
  cursor: pointer;
`;
